<template>
  <div class="main">
    <div class="multimedia">
      <div class="title">چند رسانه ای</div>
      <div class="detail">
        <FileCard icon="video" title="ویدئو" class="items" background="rgba(80, 165, 241, 0.25098)" />
        <FileCard icon="pdf" title="pdf" class="items" background="rgba(52, 195, 143, 0.25098)" />
        <FileCard icon="file" title="فایل دانلود" class="items" background="rgba(85, 110, 230, 0.25)" />
        <FileCard icon="link" title="لینک" class="items" background="rgba(254, 189, 23, 0.25)" />
      </div>
    </div>
    <div class="multimedia">
      <div class="title">پخش زنده</div>
      <div class="detail">
        <FileCard icon="online" title="جلسه آنلاین" class="items" background="rgba(136, 49, 157, 0.25)" />
      </div>
    </div>
    <div class="multimedia">
      <div class="title">سوال و جواب</div>
      <div class="detail">
        <FileCard icon="train" title="تمرین" class="items" background="rgba(227, 128, 30, 0.25)" />
        <!-- <FileCard icon="exam" title="امتحان" class="items" background="rgba(244, 106, 106, 0.25098)" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import FileCard from './FileCard.vue'
export default {
  components: { FileCard },
}
</script>

<style lang="scss" scoped>
.main {
  padding: 20px;
}

.title {
  font-size: 14px;
  font-weight: bold;
  line-height: 23px;
  color: #555555;
  margin-bottom: 30px;
}
.detail {
  display: flex;
  margin-bottom: 30px;
}

.items {
  border: 1px solid #f1f1f1;
  box-shadow: 0px 12px 24px rgba(18, 38, 63, 0.0313726);
}
</style>
